import React from "react";
import { Spinner, SpinnerSize } from '@fluentui/react';
import {Stack,IStackProps} from '@fluentui/react';


const rowProps: IStackProps = { horizontal: true, verticalAlign: 'center' };

const tokens = {
    sectionStack: {
        childrenGap: 10
    },
    spinnerStack: {
        childrenGap: 20
    }
};

class DSpinner extends React.Component {
    render() {
        return (
            <div>
                <Stack {...rowProps} tokens={tokens.spinnerStack}>

                    <Spinner size={SpinnerSize.medium} />
                </Stack>
            </div>
        );
    }
}
export default DSpinner







// WEBPACK FOOTER //
// ./src/components/CreateSite/CommonComponents/Spinner.js